import { WriteOffType } from '@repo/types';
import { get } from 'lodash';

import { WRITEOFF_TYPE_LABEL, WRITEOFF_TYPE_CLASSES } from '../constants/writeOffs';

const useWriteOffType = (mode: 'dark' | 'light') => {
  const getTypeLabel = (type: WriteOffType): string => get(WRITEOFF_TYPE_LABEL, type, type);
  const getTypeColor = (type: WriteOffType): string =>
    get(WRITEOFF_TYPE_CLASSES, `${type}.${mode}`, 'text-xtnd-dark dark:text-xtnd-light');

  return { getTypeLabel, getTypeColor };
};

export default useWriteOffType;
